const s = "styles-module__toast___V-JaZ", t = "styles-module__icon___BSXU2", _ = "styles-module__icon_close___ocNkg", o = "styles-module__toast_success___8CtpI", e = "styles-module__toast_error___eOQAE", c = "styles-module__toast_neutral___KWRPu", l = {
  toast: s,
  icon: t,
  icon_close: _,
  toast_success: o,
  toast_error: e,
  toast_neutral: c
};
export {
  l as default,
  t as icon,
  _ as icon_close,
  s as toast,
  e as toast_error,
  c as toast_neutral,
  o as toast_success
};
